import {  createSlice } from "@reduxjs/toolkit"
import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"


/**
 * Estado inicial del slice de candidato.
 *
 * @property {boolean} reload
 * @property {boolean} reloadTable
 */
const initialState = {
	reload: true,
	reloadTable: true,
}


 const reloadSlice = createSlice({
	name: "reload",
	initialState,
	reducers: {
        refresh: (state)=>{
            state.reload=!state.reload  
        },
		refreshTable: (state)=>{
			state.reloadTable=!state.reloadTable
		},
    },
	
})
export default reloadSlice

/**
 * Hook que retorna el estado del slice `performance-evaluation` desde Redux.
 *
 * @returns {{
 *   reload: boolean,
 *   reloadTable: boolean
 * }}
 *
 * @example
 * const { reload, reloadTable } = useReloadRedux();
 */
export const useReloadRedux = () => {
	return useSelector((state) => state.reload)
}

const { refresh, refreshTable } = reloadSlice.actions


export const useReloadRefresh = () => {
	const dispatch = useDispatch()
	const refreshFn = useCallback(() => {
		dispatch(refresh())
	}, [dispatch])
	return {refresh:refreshFn}
}
export const useRefreshTable = () => {
	const dispatch = useDispatch()
	const refreshTableFn = useCallback(() => {
		dispatch(refreshTable())
	}, [dispatch])
	return {refreshTable:refreshTableFn}
}